import type { SelectOption } from 'contracts/Common';

export enum CompanySiteTypeEnum {
  FACTORY = 'factory',
  DISTRIBUTION_CENTER = 'distributionCenter',
  OFFICE = 'office',
  EXTERNAL_WAREHOUSE = 'externalWarehouse',
}

export type CompanySiteType = `${CompanySiteTypeEnum}`;

const COMPANY_SITE_TYPE_LABELS: Record<CompanySiteTypeEnum, string> = {
  [CompanySiteTypeEnum.FACTORY]: 'Fábrica',
  [CompanySiteTypeEnum.DISTRIBUTION_CENTER]: 'CD',
  [CompanySiteTypeEnum.OFFICE]: 'Escritório',
  [CompanySiteTypeEnum.EXTERNAL_WAREHOUSE]: 'Armazém Externo',
};

export const COMPANY_SITE_TYPE_OPTIONS: SelectOption[] = [
  {
    value: CompanySiteTypeEnum.FACTORY,
    label: COMPANY_SITE_TYPE_LABELS[CompanySiteTypeEnum.FACTORY],
  },
  {
    value: CompanySiteTypeEnum.DISTRIBUTION_CENTER,
    label: COMPANY_SITE_TYPE_LABELS[CompanySiteTypeEnum.DISTRIBUTION_CENTER],
  },
  {
    value: CompanySiteTypeEnum.OFFICE,
    label: COMPANY_SITE_TYPE_LABELS[CompanySiteTypeEnum.OFFICE],
  },
  {
    value: CompanySiteTypeEnum.EXTERNAL_WAREHOUSE,
    label: COMPANY_SITE_TYPE_LABELS[CompanySiteTypeEnum.EXTERNAL_WAREHOUSE],
  },
];

export const getCompanySiteTypeLabel = (
  siteType?: CompanySiteType | null
): string => {
  if (!siteType) return '';
  return COMPANY_SITE_TYPE_LABELS[siteType as CompanySiteTypeEnum] ?? siteType;
};
